import React from 'react';
import PropTypes from 'prop-types';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { FormErrorGroup } from './form-error-group';

export const withFormErrorGroup = (WrappedComponent) => {
  const HOC = ({ formErrorProps, ...restProps }) => (
    <FormErrorGroup formErrorProps={formErrorProps}>
      <WrappedComponent {...restProps} />
    </FormErrorGroup>
  );

  HOC.propTypes = {
    formErrorProps: PropTypes.shape({}),
  };

  HOC.defaultProps = {
    formErrorProps: undefined,
  };

  hoistNonReactStatics(HOC, WrappedComponent);
  HOC.displayName = `withFormErrorGroup(${getDisplayName(WrappedComponent)})`;

  return HOC;
};
